import type { ColDef } from 'ag-grid-community';

export const commodityColumnDefinitions: ColDef[] = [
  {
    field: 'type',
    sort: 'asc',
    type: 'string',
  },
  {
    field: 'name',
    type: 'string',
  },
  {
    field: 'bloombergTickerCode',
    type: 'string',
  },
  {
    field: 'exchange',
    type: 'string',
  },
  {
    field: 'currency',
    type: 'currency',
  },
];
